import React from 'react';
import About from '../Components/About/About';

const AboutPage = () => {
  return (
    <>
      <About />
    </>
  );
};

export default AboutPage;
